import type { AxiosError } from 'axios';
import { useMutation, useQueryClient, type UseMutationOptions } from '@tanstack/react-query';

import type { IError } from '@/api/http';
import { useApiClient } from '@/providers/ApiClientProvider';
import API from '@/lib/API';

type UserLogoutArgs = {
  access_token: string;
};

export const useUserLogoutMutation = (
  options?: UseMutationOptions<unknown, AxiosError<IError>, UserLogoutArgs>,
) => {
  const { httpWithAuth, api } = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UserLogoutArgs): Promise<void> => {
      return await api<void>(httpWithAuth.post(API.logout, payload));
    },
    ...options,
    onSuccess(response: unknown, variables: UserLogoutArgs, context: unknown): void {
      queryClient.invalidateQueries({ queryKey: ['logout'] });
      options?.onSuccess?.(response, variables, context);
    },
  });
};
